/* Par Value Club — minimal theme behaviour */
(function () {
  'use strict';

  function initHeader(scope) {
    scope.querySelectorAll('[data-pv-menu-toggle]').forEach(function (btn) {
      if (btn.dataset.pvBound) return;
      btn.dataset.pvBound = 'true';
      btn.addEventListener('click', function () {
        var drawer = document.getElementById(btn.getAttribute('aria-controls'));
        if (!drawer) return;
        var open = drawer.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  }

  function initTabs(scope) {
    scope.querySelectorAll('[data-pv-tabs]').forEach(function (group) {
      if (group.dataset.pvBound) return;
      group.dataset.pvBound = 'true';

      var tabs = group.querySelectorAll('[data-pv-tab]');
      var panels = group.querySelectorAll('[data-pv-panel]');
      if (!tabs.length || !panels.length) return;

      function activate(id) {
        tabs.forEach(function (tab) {
          var on = tab.getAttribute('data-pv-tab') === id;
          tab.classList.toggle('is-active', on);
          tab.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        panels.forEach(function (panel) {
          panel.hidden = panel.getAttribute('data-pv-panel') !== id;
        });
        var count = group.querySelector('[data-pv-count]');
        var active = group.querySelector('[data-pv-panel="' + id + '"]');
        if (count && active && active.dataset.count) {
          count.textContent = active.dataset.count;
        }
      }

      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          activate(tab.getAttribute('data-pv-tab'));
        });
      });
    });
  }

  function initSort(scope) {
    scope.querySelectorAll('[data-pv-sort]').forEach(function (select) {
      if (select.dataset.pvBound) return;
      select.dataset.pvBound = 'true';
      select.addEventListener('change', function () {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', select.value);
        window.location.href = url.toString();
      });
    });
  }

  function initProduct(scope) {
    scope.querySelectorAll('[data-pv-thumb]').forEach(function (thumb) {
      if (thumb.dataset.pvBound) return;
      thumb.dataset.pvBound = 'true';
      thumb.addEventListener('click', function () {
        var main = document.querySelector('.pv-main-image');
        var src = thumb.getAttribute('data-src');
        if (main && src) {
          main.setAttribute('src', src);
          main.setAttribute('srcset', src);
        }
      });
    });

    scope.querySelectorAll('[data-pv-variants]').forEach(function (form) {
      if (form.dataset.pvBound) return;
      form.dataset.pvBound = 'true';
      form.addEventListener('change', function () {
        var select = form.querySelector('[name="id"]');
        var price = form.querySelector('[data-pv-price]');
        if (!select || !price) return;
        var option = select.options[select.selectedIndex];
        if (option && option.dataset.price) price.textContent = option.dataset.price;
      });
    });
  }

  function init(scope) {
    var root = scope || document;
    initHeader(root);
    initTabs(root);
    initSort(root);
    initProduct(root);
  }

  document.addEventListener('DOMContentLoaded', function () { init(document); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();